import { Dispatch } from 'react';
import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { handleError } from 'src/contexts/utils/handleError';
import { SET_LOADING } from 'src/contexts/types';
import { CREATE_SERVICE_CLIENT } from '../constants/actions';
import type { TServiceClientActionTypes } from '../types';
import type { IServiceClient } from 'src/interfaces/serviceClient';
import type { TServiceClientFromSoldLeadPayload } from 'src/modules/serviceClients/helpers/mapLeadToServiceClientFromSoldPayload';

/**
 * Upserts a service client from a sold lead.
 * Backend should: find by phone (+ store) → add vehicle, or create new service client.
 *
 * @route POST /api/v2/service-clients/from-sold-lead
 */
export const upsertServiceClientFromSoldLead = async (
    dispatch: Dispatch<TServiceClientActionTypes>,
    payload: TServiceClientFromSoldLeadPayload
): Promise<Partial<IServiceClient> | undefined> => {
    dispatch({ type: SET_LOADING });

    try {
        const res = await ApiV2.post(
            '/service-clients/from-sold-lead',
            payload,
            HEADERS({
                isReadPermissionNecessary: false,
            })
        );

        const serviceClient = res.data?.data;

        if (serviceClient) {
            dispatch({
                type: CREATE_SERVICE_CLIENT,
                payload: serviceClient,
            });
        }

        return serviceClient;
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
        return undefined;
    }
};
